import { Button } from '@99designs/common/components/Button';
import { ButtonGroup, ButtonGroupItem } from '@99designs/common/components/ButtonGroup';
import { Spinner } from '@99designs/common/components/Spinner';
import { CompactMeta_User } from '__generated__/CompactMeta_User';
import { handlePromise } from 'common/utils/Bugsnag';
import { Color } from 'projects/consts';
import { trackRemovedDesignerEvent } from 'projects/events';
import RemoveStructuredBriefDesigners from 'projects/mutations/RemoveStructuredBriefDesigners';
import React from 'react';
import CompactMeta from './BriefLayouts/CompactMeta';
import ColorComponent from './Color';
import ConfirmationModal from './ConfirmationModal';

interface Props {
    brief: {
        id: string;
        designers: CompactMeta_User[];
    };
    onConfirm: () => void;
    onDismiss: () => void;
    disabled: boolean;
    showing: boolean;
}

interface State {
    busy: boolean;
}

export default class SquarespaceDesignerConfirmationModal extends React.Component<Props, State> {
    state = {
        busy: false,
    };

    handleSubmit = () => {
        this.setState({ busy: true });
        this.props.onConfirm();
    };

    render() {
        const { brief, onDismiss, disabled, showing } = this.props;

        return (
            <ConfirmationModal
                onDismiss={onDismiss}
                heading={__('Confirm your Squarespace designers')}
                showing={showing}
            >
                <RemoveStructuredBriefDesigners>
                    {removeDesigners => (
                        <div className="designer-meta-list">
                            {brief.designers.map(designer => (
                                <div className="designer-meta-list__item" key={designer.id}>
                                    <CompactMeta
                                        designer={designer}
                                        hasFullStats={false}
                                        onRemove={id => {
                                            trackRemovedDesignerEvent({
                                                id: brief.id,
                                                designer_id: designer.id,
                                            });
                                            handlePromise(
                                                removeDesigners({
                                                    id: brief.id,
                                                    designerIds: [id],
                                                }),
                                                'SquarespaceDesignerConfirmationModal RemoveDesigners'
                                            );
                                        }}
                                    />
                                </div>
                            ))}
                        </div>
                    )}
                </RemoveStructuredBriefDesigners>
                <div style={{ textAlign: 'right' }}>
                    <ButtonGroup>
                        <ButtonGroupItem>
                            <a
                                type="button"
                                onClick={e => {
                                    e.preventDefault();
                                    return onDismiss();
                                }}
                                className="link link--back link--big-target"
                            >
                                {__('Back')}
                            </a>
                        </ButtonGroupItem>
                        <ButtonGroupItem>
                            <ColorComponent color={Color.squarespaceBlack}>
                                <Button
                                    onClick={this.handleSubmit}
                                    variations={['primary', 'jumbo', 'chameleon']}
                                    isDisabled={disabled || this.state.busy}
                                >
                                    {__("Let's do this!")}

                                    {this.state.busy && <Spinner variations={['inline']} />}
                                </Button>
                            </ColorComponent>
                        </ButtonGroupItem>
                    </ButtonGroup>
                </div>
            </ConfirmationModal>
        );
    }
}
